import React from 'react'
import { Button, H5 } from '@/components/atoms'
import { AddPlusIcon, RemoveMinusSquareIcon } from '@/components/atoms/icons'

export interface RepeatableFormSectionProps<T> {
  entries: T[]
  title: (index: number) => string
  onAdd: () => void
  onRemove: (index: number) => void
  addLabel: string
  showAdd?: boolean
  renderFields: (entry: T, index: number) => React.ReactNode
  addMoreOutWrapper?: boolean
  fieldsContainerClassName?: string
  headerIcon?: React.ReactNode
}

export function RepeatableFormSection<T>({
  entries,
  title,
  onAdd,
  onRemove,
  addLabel,
  showAdd = true,
  renderFields,
  addMoreOutWrapper = false,
  fieldsContainerClassName = 'flex flex-col gap-6 md:flex-row md:flex-wrap lg:grid lg:grid-cols-2',
  headerIcon,
}: RepeatableFormSectionProps<T>) {
  return (
    <div className="flex flex-col gap-8">
      {entries.map((entry, i) => (
        <div
          key={i}
          className="flex flex-col gap-4 rounded-2xl border border-indigo-50 px-6 pt-6 pb-8 md:px-8"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              {headerIcon}
              <H5 className="text-2xl! font-semibold text-neutral-900">
                {showAdd ? title(i) : title(i).replace(/\s\d+$/, '')}
              </H5>
            </div>
            {showAdd && entries.length > 1 && (
              <Button
                type="button"
                variant="link"
                onClick={() => onRemove(i)}
                className="h-5.5 w-5.5 p-0 hover:opacity-70"
              >
                <RemoveMinusSquareIcon
                  borderClassName="stroke-indigo-base"
                  lineClassName="stroke-indigo-base"
                />
              </Button>
            )}
          </div>
          <div className={fieldsContainerClassName}>
            {renderFields(entry, i)}
            {showAdd && i === entries.length - 1 && (
              <div
                className={`pb-0 md:mt-auto md:h-12 ${!addMoreOutWrapper ? 'flex' : 'flex md:hidden'}`}
              >
                <Button
                  type="button"
                  variant="link"
                  size="md"
                  leadingIcon={AddPlusIcon}
                  onClick={onAdd}
                  className="hover:opacity-70"
                >
                  {addLabel}
                </Button>
              </div>
            )}
          </div>
        </div>
      ))}
      {showAdd && addMoreOutWrapper && (
        <div className="ml-auto hidden md:flex">
          <Button
            type="button"
            variant="link"
            size="md"
            leadingIcon={AddPlusIcon}
            onClick={onAdd}
            className="pb-0 hover:opacity-70"
          >
            {addLabel}
          </Button>
        </div>
      )}
    </div>
  )
}
